/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierPackageMarkAsDeliveredRequest
 */
export interface CourierPackageMarkAsDeliveredRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierPackageMarkAsDeliveredRequest
     */
    courierPackageId?: string;
}

/**
 * Check if a given object implements the CourierPackageMarkAsDeliveredRequest interface.
 */
export function instanceOfCourierPackageMarkAsDeliveredRequest(value: object): value is CourierPackageMarkAsDeliveredRequest {
    return true;
}

export function CourierPackageMarkAsDeliveredRequestFromJSON(json: any): CourierPackageMarkAsDeliveredRequest {
    return CourierPackageMarkAsDeliveredRequestFromJSONTyped(json, false);
}

export function CourierPackageMarkAsDeliveredRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierPackageMarkAsDeliveredRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'courierPackageId': json['courierPackageId'] == null ? undefined : json['courierPackageId'],
    };
}

export function CourierPackageMarkAsDeliveredRequestToJSON(json: any): CourierPackageMarkAsDeliveredRequest {
    return CourierPackageMarkAsDeliveredRequestToJSONTyped(json, false);
}

export function CourierPackageMarkAsDeliveredRequestToJSONTyped(value?: CourierPackageMarkAsDeliveredRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courierPackageId': value['courierPackageId'],
    };
}

